import { render } from "./ModalUploadInvoiceXMLFile.vue?vue&type=template&id=1f18bae5&scoped=true&ts=true"
import script from "./ModalUploadInvoiceXMLFile.vue?vue&type=script&lang=ts"
export * from "./ModalUploadInvoiceXMLFile.vue?vue&type=script&lang=ts"

import "./ModalUploadInvoiceXMLFile.vue?vue&type=style&index=0&id=1f18bae5&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/pontuei/pontuei-painel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f18bae5"]])

export default __exports__